import React from 'react';
import Tile from './Tile.js'
import { Tooltip } from 'react-tooltip';

export default class TileSelector extends React.Component {

  renderTile(image, orientation, label, toolTip = undefined) {
    const className = label === this.props.selectedLabel ? "selected" : "";
  
    return <Tile 
      className={className}
      image={image}
      orientation={orientation}
      onClick={() => this.props.onClick(label)}
      toolTip={toolTip}
    />
  }

  render() {
    return(
      <div className="tile-selector">
        <h1>Tile Selector</h1>
        <div className="tiles">
          <div className="selector-row">
            {this.renderTile("/images/four-64.png", "UP", "fourTile")}
            {this.renderTile("/images/zero-64.png", "UP", "zeroTile")}
          </div>

          <div className="selector-row">
            {this.renderTile("/images/three-64.png", "RIGHT", "threeRightTile")}
            {this.renderTile("/images/three-64.png", "DOWN", "threeDownTile")}
            {this.renderTile("/images/three-64.png", "LEFT", "threeLeftTile")}
            {this.renderTile("/images/three-64.png", "UP", "threeUpTile")}
          </div>

          <div className="selector-row">
            {this.renderTile("/images/two-hall-64.png", "RIGHT", "twoHallHorizontalTile")}
            {this.renderTile("/images/two-hall-64.png", "UP", "twoHallVerticalTile")}
          </div>

          <div className="selector-row">
            {this.renderTile("/images/two-corner-64.png", "RIGHT", "twoCornerRightTile")}
            {this.renderTile("/images/two-corner-64.png", "DOWN", "twoCornerDownTile")}
            {this.renderTile("/images/two-corner-64.png", "LEFT", "twoCornerLeftTile")}
            {this.renderTile("/images/two-corner-64.png", "UP", "twoCornerUpTile")}
          </div>

          <div className="selector-row">
            {this.renderTile("/images/one-64.png", "RIGHT", "oneRightTile")}
            {this.renderTile("/images/one-64.png", "DOWN", "oneDownTile")}
            {this.renderTile("/images/one-64.png", "LEFT", "oneLeftTile")}
            {this.renderTile("/images/one-64.png", "UP", "oneUpTile")}
          </div>
        </div>

        <div className="specialTiles">
          <div className="selector-row">
            {this.renderTile("/images/exit.png", "RIGHT", "exitTile", "Exit (required)")}
            {this.renderTile("/images/star.png", "RIGHT", "playerStart", "Player Start (required)")}
            {this.renderTile("/images/key.png", "RIGHT", "key", "Key (required)")}
          </div>
        </div>

        <div className="enemies">
          <div className="selector-row">
            {this.renderTile("/images/spotter.png", "RIGHT", "spotter", "Place Enemy")}
          </div>
          <div className="selector-row">
            {this.renderTile("/images/remove-enemy.png", "RIGHT", "removeEnemy", "Remove Enemy")}
          </div>
        </div>
        <Tooltip />
      </div>
    );
  }
}
